import React from 'react';
import Cropper from 'react-cropper';

import { useIsMobile } from '@app/hooks/useIsMobile';
import '@app/scss/localCommon/components/imageCropper.scss';

const ImageCropper = ({
	image,
	setImage,
	initFile,
	setCroppedImage,
	uploadFile,
	setCropperModal,
	aspectRatio,
	cropperButton = false,
}) => {
	const [cropper, setCropper] = React.useState<any>();
	const [base64Data, setBase64Data] = React.useState();
	const isMobile = useIsMobile();

	const reader: any = new FileReader();
	reader.readAsDataURL(image);

	reader.onloadend = () => {
		setBase64Data(reader.result);
	};

	const getCropData = () => {
		if (typeof cropper !== 'undefined') {
			fetch(`${cropper.getCroppedCanvas().toDataURL('image/jpeg')}`)
				.then((res) => res.blob())
				.then((blob) => {
					const croppedFile = new File([blob], initFile.name, { type: initFile.type, lastModified: Date.now() });
					setCroppedImage({ croppedImage: croppedFile });
					const url = window.URL.createObjectURL(croppedFile);

					uploadFile({
						file: croppedFile,
						filename: 'file',
						headers: { 'No-Relation': 'true' },
						method: 'post',
						extension: 'jpg',
					});
				});
			setCropperModal(false);
		}
	};

	return (
		<div className="image-cropper">
			<h3 className="image-cropper-title">
				Rotate image if needed.
				<br />
				Upload image when done.
			</h3>

			{isMobile && (
				<div className="text-center">
					<button onClick={getCropData} className="btn btn-primary">
						Upload Image
					</button>
				</div>
			)}
			<div className="image-cropper-wrapper">
				<Cropper
					style={{ height: 400, width: '100%' }}
					restore={false}
					zoomTo={0}
					initialAspectRatio={aspectRatio}
					preview=".img-preview"
					src={base64Data}
					viewMode={0}
					dragMode="none"
					rotatable
					guides={false}
					minCropBoxHeight={50}
					minCropBoxWidth={50}
					background={false}
					zoomable={false}
					center
					highlight={false}
					zoomOnTouch={false}
					zoomOnWheel={false}
					responsive
					autoCrop={false}
					autoCropArea={1}
					checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
					onInitialized={(instance) => {
						setCropper(instance);
					}}
				/>
			</div>

			<div className="image-cropper-btns">
				{!isMobile && (
					<button className="btn btn-secondary" onClick={() => setCropperModal(false)}>
						Cancel
					</button>
				)}

				{!isMobile && (
					<button onClick={getCropData} className="btn btn-primary">
						Upload Image
					</button>
				)}
				<div className="btns-nav">
					<button onClick={() => cropper.rotate(90)} className="btn-nav btn-rotate">
						<div>
							<img src={require('@app/images/rotate-arrow.svg')} alt="rotate" />
							<br />
							Rotate
						</div>
					</button>
					{isMobile && (
						<button onClick={() => setCropperModal(false)} className="btn-nav btn-adjust">
							<div>
								<img src={require('@app/images/close_dark_wide.svg')} alt="adjust" />
								<br />
								Cancel
							</div>
						</button>
					)}
					{cropperButton && (
						<button
							onClick={() => {
								cropper.setDragMode('crop');
								cropper.reset();
								cropper.crop();
							}}
							className="btn-nav btn-adjust"
						>
							<div>
								<img src={require('@app/images/adjust-icon.svg')} alt="adjust" />
								<br />
								Crop
							</div>
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default ImageCropper;
